import { append, clone, not } from 'ramda';
import {
  dxCategories,
  cbdDiagnoses,
  dlbDiagnoses,
  dmdDiagnoses,
  msaDiagnoses,
  msDiagnoses,
  pdDiagnoses,
  pspDiagnoses,
  smaDiagnoses,
  huntingtonDiagnoses,
  epilepsyDiagnoses,
  parkinsonDiagnoses,
  sleepApneaDiagnoses,
  keoDiagnoses,
  reoDiagnoses,
  nmosdDiagnoses,
  mgravisDiagnoses,
} from '../definitions';

export const chooseDiagnosesByCategory = (category: string): Array<TDiagnosis> => {
  switch (category) {
    case 'diagnosis.opts.SMA':
      return smaDiagnoses;
    case 'diagnosis.opts.DMD':
      return dmdDiagnoses;
    case 'diagnosis.opts.PD':
      return pdDiagnoses;
    case 'diagnosis.opts.PSP':
      return pspDiagnoses;
    case 'diagnosis.opts.MSA':
      return msaDiagnoses;
    case 'diagnosis.opts.DLB':
      return dlbDiagnoses;
    case 'diagnosis.opts.CBD':
      return cbdDiagnoses;
    case 'diagnosis.opts.MS':
      return msDiagnoses;
    case 'diagnosis.opts.HD':
      return huntingtonDiagnoses;
    case 'diagnosis.opts.SR':
      return sleepApneaDiagnoses;
    default:
      return [];
  }
};

export const chooseCategoryTitle = (diagnosis: TDiagnosis): string => {
  const category = dxCategories.find((o: ICategoryOptions) => o.values.includes(diagnosis));
  return category?.title ?? '';
};

export const findMissingDiagnosis = (docDiagnosis: TDiagnosis, category: ICategoryOptions): boolean =>
  not(category.values.includes(docDiagnosis));

export const addMissingDiagnosis = (docDiagnosis: TDiagnosis, category: ICategoryOptions): Array<TDiagnosis> => {
  let values = clone(category.values);
  if (chooseDiagnosesByCategory(category.title).includes(docDiagnosis)) {
    values = append(docDiagnosis, category.values);
  }
  return values as Array<TDiagnosis>;
};

export const findIfCategoryIsMissing = (
  docDiagnosis: TDiagnosis,
  diagnosisCategoryOptions: Array<ICategoryOptions>,
): boolean =>
  not(
    diagnosisCategoryOptions.find((category: ICategoryOptions) => category.title === chooseCategoryTitle(docDiagnosis)),
  );

/**
 * Generate a diagnosis (i.e. "dx") to platform map, indicating which
 * platform a diagnosis belongs to.
 * @returns Diagnosis-to-platform map
 */
export const generateDxToPlatfMap = (): { [key in TDiagnosis]?: Platform } => {
  const dxToPlatfMap: { [key in TDiagnosis]?: Platform } = {};
  const platfToDxMap: { [key in Platform]: TDiagnosis[] } = {
    dmd: dmdDiagnoses,
    epilepsy: epilepsyDiagnoses,
    huntington: huntingtonDiagnoses,
    ms: [...msDiagnoses, ...keoDiagnoses, ...reoDiagnoses, ...nmosdDiagnoses],
    parkinson: parkinsonDiagnoses,
    sma: smaDiagnoses,
    sleepApnea: sleepApneaDiagnoses,
    ninmt: [],
    mgravis: [...mgravisDiagnoses],
  };

  (Object.keys(platfToDxMap) as Platform[]).forEach(plat => {
    platfToDxMap[plat].forEach(dx => {
      dxToPlatfMap[dx] = plat;
    });
  });

  return dxToPlatfMap;
};
